import { isPhoneNumberValid, trimAllWhiteCharacters } from 'noddi-util';
import { z } from 'zod';

export const zodAddressSchema = z.object({ id: z.number(), name: z.string() }, { message: 'Address is required' });

export const zodEmailSchema = z.email('Invalid email format').min(1, 'Email is required');

// Optional variant: empty string passes, anything else must be a valid email.
export const zodOptionalEmailSchema = z.email('Invalid email format').or(z.literal(''));

export const zodUrlSchema = z.url('Invalid URL format').min(1, 'URL is required');

export const zodPhoneNumberSchema = z
  .string()
  .min(1, 'Phone number is required')
  // Validation tolerance only: trims whitespace so the validity check accepts
  // padded input. TanStack Form never applies transform output, so the RAW
  // (untrimmed) value is what gets submitted — the backend normalizes it.
  // eslint-disable-next-line noddi/prefer-zod-input -- trim only feeds the refine; TanStack Form submits the raw value and the backend normalizes it
  .transform((v) => trimAllWhiteCharacters(v))
  .refine(
    (v) => isPhoneNumberValid(v),
    'Must be a valid phone number with country code (e.g. +123456789012) 8-15 digits'
  );

// Optional variant: empty string passes, anything else must be a valid phone number.
export const zodOptionalPhoneNumberSchema = zodPhoneNumberSchema.or(z.literal(''));
